import React from 'react';

const LandingHeadingText = ({children, additionalclasses}) => {
    return (
        <p className={`text-[24px] lg:text-[44px] poppins-medium text-grey-900 ${additionalclasses}`}>{children}</p>
    );
};

export default LandingHeadingText;